/* Welcome newsletter popup — email capture → subscribe → reveal a copyable
   discount code. One show per visitor. Vanilla JS, no deps.
   The email itself is sent by a Shopify Email "welcome/subscriber" automation
   triggered when the customer subscribes below. */
(function () {
  var root = document.getElementById('fz-reward');
  if (!root) return;

  // UI strings from snippets/fz-strings.liquid; the English here is the
  // fallback for a key that is missing.
  var fzT = window.fzT || {};
  function fillIn(s, o) { s = String(s); for (var x in o) s = s.split("[" + x + "]").join(o[x]); return s; }
  function tr(k, en, o) { return fillIn(fzT[k] || en, o); }

  var CODE = (root.dataset.code || 'FLOWZA10').trim();
  var FREQ = (root.dataset.frequency || 'once').trim();
  var REDIRECT = root.dataset.redirect || (((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'collections/all');
  var KEY = 'fz_reward_v2'; // bumped from v1 so past game-players see the new popup once
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  // Don't interrupt the cart/checkout flow -- or a product page, which is
  // where the decision actually gets made. AI-shopper testing found shoppers
  // dismissing this mid-evaluation on product and bundle pages, and one lost
  // their place entirely. The offer still lands on the home, collection and
  // content pages, which is where a first-time visitor meets the store.
  if (/\/(cart|checkout|products)(\/|$)/.test(location.pathname)) return;

  function seen() {
    if (designMode || FREQ === 'always') return false;
    var store = FREQ === 'session' ? sessionStorage : localStorage;
    try { return store.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function markSeen() {
    if (designMode) return;
    var store = FREQ === 'session' ? sessionStorage : localStorage;
    try { store.setItem(KEY, '1'); } catch (e) {}
  }
  if (seen()) return;

  var stage = document.getElementById('fzr-stage');
  var win = document.getElementById('fzr-win');
  var form = document.getElementById('fzr-form');
  var emailEl = document.getElementById('fzr-email');
  var submitBtn = document.getElementById('fzr-submit');
  var errEl = document.getElementById('fzr-err');

  // ---- open / close ----
  var opened = false;
  function open() {
    if (opened) return; opened = true;
    // Recorded on OPEN, not only on dismiss. markSeen() used to run from
    // close() and reveal() alone, so a visitor who was shown the popup and
    // then navigated (tapped a link behind it, or went back) was never marked
    // -- and met it again on the next page, and the next. Eight AI shoppers
    // hit it repeatedly across FAQ, product and bundle pages. Once it has been
    // shown, it has been shown.
    markSeen();
    root.classList.add('fzr-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fzr-lock');
    setTimeout(function () { try { emailEl.focus(); } catch (e) {} }, 400);
  }
  function close() {
    root.classList.remove('fzr-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fzr-lock');
    markSeen();
  }
  root.querySelectorAll('[data-fzr-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && opened) close(); });

  function reveal() {
    if (!win.hidden) return;
    stage.style.display = 'none';
    win.hidden = false;
    markSeen();
  }

  // ---- copy + cta ----
  var copyBtn = document.getElementById('fzr-copy');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var done = function () { copyBtn.textContent = tr('copied', 'Copied!'); copyBtn.classList.add('is-copied'); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(CODE).then(done, done);
    else done();
  });
  var cta = document.getElementById('fzr-cta');
  if (cta) cta.setAttribute('href', '/discount/' + encodeURIComponent(CODE) + '?redirect=' + encodeURIComponent(REDIRECT));

  // ---- submit: subscribe (best effort), then reveal the code ----
  // The code is always revealed so the visitor can copy it even if the network
  // hiccups; the emailed copy depends on the subscribe POST reaching Shopify.
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    if (!emailEl.checkValidity()) { emailEl.reportValidity(); return; }
    submitBtn.disabled = true;
    submitBtn.textContent = tr('sending', 'Sending…');

    var finish = function () { reveal(); };
    try {
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(finish, finish);
    } catch (err) { finish(); }
    // Safety net: never leave the visitor stuck if the request hangs
    setTimeout(finish, 2500);
  });

  // ---- launch on intent, not on a timer ----
  // This used to open 1.3s after load. 91% of traffic is mobile and most of it
  // lands from paid social on a collection page, so the first thing a visitor
  // saw was a full-screen email form over a store they had not seen yet --
  // and Google treats a mobile interstitial that early as a ranking negative.
  // Now it waits for a sign of interest: a scroll a third of the way down, or
  // 20 seconds. Someone who bounces in six seconds is never interrupted; the
  // engaged visitor still gets the offer.
  function launch() {
    if (designMode) { setTimeout(open, 200); return; }

    // A shopper who arrived from a Meta ad came for one product, and the
    // scroll trigger below can fire inside the first few seconds of them
    // finding it. Hold the offer back for 8s on that landing page only --
    // the UTM is on the landing URL and nowhere else, so later pages are
    // unaffected.
    var HOLD_MS = 8000;
    var fromSocial = /[?&]utm_source=(facebook|instagram|ig)(?=&|$)/i.test(location.search);
    var landed = Date.now();

    var fired = false;
    function go() {
      if (fired) return;
      var wait = fromSocial ? HOLD_MS - (Date.now() - landed) : 0;
      if (wait > 0) { setTimeout(go, wait); return; }
      fired = true;
      window.removeEventListener('scroll', onScroll);
      clearTimeout(timer);
      open();
    }
    function onScroll() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      if ((window.scrollY || doc.scrollTop) / scrollable >= 0.30) go();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    var timer = setTimeout(go, 20000);
  }
  if (document.readyState === 'complete') launch();
  else window.addEventListener('load', launch);
})();
